export const ICONS = {
    DASHBOARD: 'dashboard',
    HOME: 'home',
    USERS: 'users',
    SEND_INSPECTION: 'send-inspection',
    INSPECTION_REPORT: 'inspection-report',
    ORGANIZATION: 'organization',
    AUDIT_LOGS: 'audit-logs',
    DRIVER_LOGS: 'driver-logs',
    SETTINGS: 'settings',
    LOGOUT: 'logout',
    MAIL: 'mail',
    LOCK: 'lock',
    SSO_LOGIN: 'sso-login',
    VISIBILITY: 'visibility',
    VISIBILITY_OFF: 'visibility_off',
    ERROR_OUTLINE: 'error-outline',
    CHEVRON_LEFT: 'chevron-left',
    MENU: 'menu',
    ARROW_FORWARD: 'arrow-forward',
    BACK_ARROW: 'back_arrow',
    VALIDATE: 'validate',
    EDIT: 'edit',
    DELETE: 'delete',
    ARCHIVE: 'archive',
    ARCHIVE_WHITE: 'archive-white',
    USER_EDIT: 'user-edit',
    USER_GROUP: 'user-group',
    SENT: 'sent',
    KEY_GREEN: 'key-green',
    KEY_GREY: 'key-grey',
    KEY_RED: 'key-red',
    MAIL_GREEN: 'mail-green',
    MAIL_GREY: 'mail-grey',
    MAIL_RED: 'mail-red',
    EDIT_BLUE: 'edit-blue',
    ADD_BLUE: 'add-blue',
    IMPORT_MENU: 'import-menu',
    DOWNLOAD: 'download',
    CARRIER_MASTER: 'carrier-master',
    WARNING: 'warning'
} as const;
